import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { GameEntity } from '@okletsplay/core';
import React, { FC, useMemo } from 'react';
import { register } from 'swiper/swiper-element';
import { GameCarouselItem } from './GameCarouselItem';
import { useStyles } from './MobileGameCarousel.styles';
import { orderBy } from 'lodash';

register();

interface GamesCarouselProps {
  games: (GameEntity & { order?: number })[];
}

export const MobileGameCarousel: FC<GamesCarouselProps> = ({ games }) => {
  const theme = useTheme();
  const { classes } = useStyles();
  const isMobileView = useMediaQuery(theme.breakpoints.down('md'));

  const gameCards = useMemo(() => orderBy(games, ['order'], ['asc']), [games]);

  return (
    <Box className={classes.root}>
      {!isMobileView && (
        <Typography variant="h3" pt={0} sx={{ textTransform: 'uppercase' }}>
          Games
        </Typography>
      )}

      <swiper-container loop={true} slides-per-view="auto">
        {gameCards.map((game, index) => (
          <swiper-slide key={game?.id ?? index}>
            <GameCarouselItem game={game} />
          </swiper-slide>
        ))}
      </swiper-container>
    </Box>
  );
};
